export { default as MixRoom } from './room'
export { default as MixPage } from './page'
export { default as MixDraft } from './draft'



// WEBPACK FOOTER //
// ./client/src/mixins/index.js